'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".CustomComponent-module_iframe__GFzkA{background-color:transparent;border:0;display:none;margin:0;padding:0;width:100%}";
var styles = {"iframe":"CustomComponent-module_iframe__GFzkA"};
styleInject["default"](css_248z, '9b4636e4-a8df-4bef-b4cc-f45fba3b5d11');

exports["default"] = styles;
